var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',{staticClass:"to-top-btn",style:({
    background: _vm.backgroundColor,
    color: _vm.color,
  }),attrs:{"bottom":150,"right":50}},[_c('i',{staticClass:"el-icon-arrow-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }